import * as _ from 'underscore'

import { Enums } from "../../models/common"
import { CorrespondingActionTypeModel, FieldModel } from "../../modules/api/api.models"
import { EventsNames, ConvertHelper } from "../../helpers"
import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"
import { OpActionType, OpActionData } from "../../models/core"
import { DataValue } from "../../models/local"

//#region Public Types

export const ACTION_SERVICE_NAME = 'actionService'
export const ACTION_SERVICE_PROVIDER_NAME = 'actionServiceProvider'

//#endregion

export class ActionService {

    public static get LOG_PREFIX(): string { return '[SIMAX.Module.Common.Action]' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdAction };
    public static get FILE_NAME_PREFIX(): string { return 'action' };

    // #region Ctor

    constructor(private userSession: UserSessionService) { }

    // #endregion


    // #region Public Methods

    /**run action directly, without popup with parameters */
    public runAction($scope: ng.IScope, action: CorrespondingActionTypeModel, popupId: number) {
        $scope.$root.$broadcast(EventsNames.RUN_ACTION_DIRECTLY + popupId, action)
    }

    public getCorrespondingActionType(referenceIds: number[], referenceType: Enums.ReferenceType): JQueryPromise<OpActionType[]> {
        return this.userSession
            .getDataProvider()
            .Action
            .getCorrespondingActionType(referenceIds, referenceType)
            .then((actionTypes: OpActionType[]) => {
                return actionTypes
            })
    }


    public getActionParameters(idActionType: number, referenceType: Enums.ReferenceType, referenceIds: number[]): JQueryPromise<OpActionData[]> {
        return this.userSession
            .getDataProvider()
            .Action
            .getActionParameters(idActionType, referenceType, referenceIds)
            .then((actionData: OpActionData[]) => {
                return actionData
            })
    }

    public getDataValues(action: CorrespondingActionTypeModel): DataValue[] {
        let dataValues: DataValue[] = [];
        if (!action.isActionDataFixed && _.size(action.fields) > 0) {
            dataValues = action.fields.map((field:FieldModel) => {
                if (field.typeId == Enums.DataTypeClass.Time) {
                    return new DataValue(field.idDataType, field.index, ConvertHelper.stringToDate(field.value));
                }
                return new DataValue(field.idDataType, field.index, field.value);
            })
        }

        return dataValues
    }

    // #endregion


    // #region Private Methods


    // #endregion
}

export class ActionServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSession: UserSessionService) {
        return new ActionService(userSession)
    }]

    //#endregion
} 
